import { SvgIcon, SvgIconProps } from '@mui/material';

export const StrengthIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 127 127" {...props}>
      <path
        fill="#009657"
        d="M112.5,88.28V37.76c0-4.47-2.38-8.59-6.25-10.83L62.5,1.67c-3.87-2.23-8.63-2.23-12.5,0L6.25,26.93
              C2.38,29.17,0,33.29,0,37.76v50.52c0,4.47,2.38,8.59,6.25,10.83L50,124.36c3.87,2.23,8.63,2.23,12.5,0l43.75-25.26
              C110.12,96.87,112.5,92.74,112.5,88.28z"
      />
      <path
        fill="#5DD1A4"
        d="M58.72,71.23c-0.29,0-0.58-0.05-0.86-0.15c-0.79-0.29-1.39-0.96-1.58-1.79l-3.03-13.18l-4.01,7.99
                  c-0.42,0.85-1.29,1.38-2.23,1.38h-8.36c-1.38,0-2.5-1.12-2.5-2.5c0-1.38,1.12-2.5,2.5-2.5h6.81l6.43-12.82
                  c0.47-0.94,1.5-1.48,2.53-1.36c1.05,0.13,1.9,0.9,2.14,1.92l3.72,16.19l4.56-3.43c0.43-0.33,0.96-0.5,1.5-0.5h9.03
                  c1.38,0,2.5,1.12,2.5,2.5c0,1.38-1.12,2.5-2.5,2.5h-8.2l-6.97,5.25C59.79,71.06,59.26,71.23,58.72,71.23z"
      />
      <path
        fill="#5DD1A4"
        d="M91.79,55.63h4.14c0.58,0,1.05,0.47,1.05,1.05v12.63c0,0.58-0.47,1.05-1.05,1.05h-4.14V55.63z"
      />
      <path
        fill="white"
        d="M90.33,76.72h-5.92c-0.81,0-1.46-0.66-1.46-1.46V50.74c0-0.81,0.66-1.46,1.46-1.46h5.92
                    c0.81,0,1.46,0.66,1.46,1.46v24.52C91.79,76.07,91.13,76.72,90.33,76.72z"
      />
      <path
        fill="white"
        d="M78.97,81.51h-5.45c-0.94,0-1.7-0.76-1.7-1.7V46.18c0-0.94,0.76-1.7,1.7-1.7h5.45
                    c0.94,0,1.7,0.76,1.7,1.7v33.64C80.67,80.75,79.91,81.51,78.97,81.51z"
      />
      <path
        fill="#5DD1A4"
        d="M20.76,70.36h-4.14c-0.58,0-1.05-0.47-1.05-1.05V56.68c0-0.58,0.47-1.05,1.05-1.05h4.14V70.36z"
      />
      <path
        fill="white"
        d="M22.22,49.27h5.92c0.81,0,1.46,0.66,1.46,1.46v24.52c0,0.81-0.66,1.46-1.46,1.46h-5.92
                    c-0.81,0-1.46-0.66-1.46-1.46V50.73C20.76,49.92,21.42,49.27,22.22,49.27z"
      />
      <path
        fill="white"
        d="M33.58,44.48h5.45c0.94,0,1.7,0.76,1.7,1.7v33.64c0,0.94-0.76,1.7-1.7,1.7h-5.45
                    c-0.94,0-1.7-0.76-1.7-1.7V46.18C31.88,45.24,32.64,44.48,33.58,44.48z"
      />
    </SvgIcon>
  );
};
